import unauthorizedImage from './unauthorizedImage.webp';

export default unauthorizedImage;
